import React from 'react';

export const RoleSummary = ({ rolesSummary }) => {
  if (!rolesSummary) return null;

  return (
    <div className="space-y-4 mb-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-testid="roles-summary">
        <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
          <p className="text-[10px] text-gray-500 uppercase tracking-wider font-medium mb-1">Total Roles</p>
          <p className="text-xl font-bold text-[#0A1F44]">{rolesSummary.total_roles}</p>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
          <p className="text-[10px] text-gray-500 uppercase tracking-wider font-medium mb-1">Total Candidates</p>
          <p className="text-xl font-bold text-green-600">{rolesSummary.total_candidates}</p>
          {rolesSummary.pipeline_health && (
            <p className="text-[10px] text-gray-400 mt-0.5">Avg Score: <span className="font-semibold text-[#0A1F44]">{rolesSummary.pipeline_health.global_avg_score}</span></p>
          )}
        </div>
        {Object.entries(rolesSummary.by_vertical || {}).map(([k, v]) => (
          <div key={k} className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
            <p className="text-[10px] text-gray-500 uppercase tracking-wider font-medium mb-1">{v.label}</p>
            <p className="text-xl font-bold text-[#0A1F44]">{v.roles} <span className="text-sm font-normal text-gray-400">roles</span></p>
            <p className="text-[10px] text-gray-400">{v.candidates} candidates</p>
          </div>
        ))}
      </div>

      {/* Pipeline Health Bar */}
      {rolesSummary.pipeline_health && (rolesSummary.pipeline_health.strong > 0 || rolesSummary.pipeline_health.medium > 0 || rolesSummary.pipeline_health.weak > 0) && (
        <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm" data-testid="pipeline-health-bar">
          <p className="text-[10px] text-gray-500 uppercase tracking-wider font-medium mb-2">Pipeline Health Overview</p>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-1.5">
                <span className="h-2.5 w-2.5 rounded-full bg-emerald-500 inline-block"></span>
                <span className="text-xs text-gray-700 font-medium">{rolesSummary.pipeline_health.strong} Strong</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="h-2.5 w-2.5 rounded-full bg-amber-400 inline-block"></span>
                <span className="text-xs text-gray-700 font-medium">{rolesSummary.pipeline_health.medium} Medium</span>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="h-2.5 w-2.5 rounded-full bg-red-400 inline-block"></span>
                <span className="text-xs text-gray-700 font-medium">{rolesSummary.pipeline_health.weak} Weak</span>
              </div>
              {rolesSummary.pipeline_health.empty > 0 && (
                <div className="flex items-center gap-1.5">
                  <span className="h-2.5 w-2.5 rounded-full bg-gray-300 inline-block"></span>
                  <span className="text-xs text-gray-700 font-medium">{rolesSummary.pipeline_health.empty} No Candidates</span>
                </div>
              )}
            </div>
            <div className="flex-1 h-3 bg-gray-100 rounded-full overflow-hidden flex">
              {(() => {
                const h = rolesSummary.pipeline_health;
                const total = h.strong + h.medium + h.weak + h.empty;
                if (!total) return null;
                return (<>
                  {h.strong > 0 && <div className="bg-emerald-500 h-full transition-all" style={{ width: `${(h.strong / total) * 100}%` }}></div>}
                  {h.medium > 0 && <div className="bg-amber-400 h-full transition-all" style={{ width: `${(h.medium / total) * 100}%` }}></div>}
                  {h.weak > 0 && <div className="bg-red-400 h-full transition-all" style={{ width: `${(h.weak / total) * 100}%` }}></div>}
                  {h.empty > 0 && <div className="bg-gray-300 h-full transition-all" style={{ width: `${(h.empty / total) * 100}%` }}></div>}
                </>);
              })()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
